define('widgets/dgrid/blocks/valuable/valuable',['underscore', 'knockout'], function (_, ko) {

    var ValuableBlock = function (session, itemManager, adventurers, getFields) {
        var self = this;

        self.ctaText = getFields('cta_text');
        self.backgroundColor = getFields('background_color');

        self.itemManager = itemManager;

        self.playerIdOrCasumoName = ko.observable().withFallback(session.id);

        self.adventurer = ko.pureComputed(function() {
            return adventurers.getByPlayerIdOrCasumoName(self.playerIdOrCasumoName());
        });

        self.usableItems = ko.pureComputed(function() {
            return self.adventurer().getAdventure().freshOrUsedEarnedItemsByPriority();
        });

        self.usableSupportedItems = ko.pureComputed(function() {
            var items = _.filter(self.usableItems(), function(elm) {
                return elm.isSupportedOnDevice();
            });

            return items;
        });

        self.firstItem = ko.pureComputed(function() {
            return _.first(self.usableSupportedItems());
        });

        self.isClicked = ko.observable(false);

    };

    ValuableBlock.prototype.useItem = function(item) {
        this.itemManager.useItem(item).then(this.onUse);
    };

    ValuableBlock.prototype.activate = function(settings) {
        var self = this;

        self.activateFallback = settings.activateFallback;

        self.usableSupportedItems.subscribeAndExec(function() {
            return self.activateFallback(_.isEmpty(self.usableSupportedItems()));
        });
    };

    return ValuableBlock;
});

